
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import AlerteModel from '@/models/AlerteModel'
import convertDateDirective from '@/directives/convertDateDirective'
import {isCoprolibDate} from '@/helpers/validators'
import moment from 'moment'
import {convertDateTimeForUi} from '@/helpers'

@Component({
  components: {
    BaseFormContainer
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {}
  }
})
export default class AlerteForm extends BaseForm {
  model = AlerteModel
  noTime = false

  @Watch('data.DATE_HEURE', {deep: true})
  watchDataDateHeure(val: any) {
    if (val) {
      const hours = moment(val).utc().hours()
      const minutes = moment(val).utc().minutes()
      if (hours === 0 && minutes === 0) {
        this.noTime = true
      } else {
        this.noTime = false
        Vue.set(this.form, 'DATE_HEURE', convertDateTimeForUi(val))
      }
      this.formDefault = Object.assign({}, this.form)
    }
  }

  @Watch('noTime', {deep: false})
  watchNoTime(val: any) {
    if (val) {
      const {DATE_HEURE}: any = this.form
      const withoutTime = moment(DATE_HEURE, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY')
      Vue.set(this.form, 'DATE_HEURE', withoutTime)
    }
  }

  get labelDatePicker() {
    return this.noTime ? 'Choisir une date' : 'Choisir une Date / Heure'
  }

  get formatDatePicker() {
    return this.noTime ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm'
  }

  get formattedDatePicker() {
    return this.noTime ? 'll' : 'lll'
  }
}
